module.exports = __webpack_public_path__ + "img/arrow-down.f32e49fd.svg";